import { Link } from 'react-router-dom';
import { X, GitCompare, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCompare } from '@/hooks/useCompare';
import { cn } from '@/lib/utils';

export function CompareBar() {
  const { selectedTools, removeTool, clearAll } = useCompare();

  if (selectedTools.length === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t shadow-lg animate-slide-in-up">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <GitCompare className="h-5 w-5 text-primary" />
            <span className="font-medium">Compare ({selectedTools.length}/4)</span>
          </div>

          <div className="flex-1 flex items-center gap-2 overflow-x-auto">
            {selectedTools.map(tool => (
              <div 
                key={tool.id}
                className="flex items-center gap-2 bg-muted rounded-lg px-3 py-2 shrink-0"
              >
                <div className="w-6 h-6 rounded bg-background flex items-center justify-center overflow-hidden">
                  {tool.logo_url ? (
                    <img src={tool.logo_url} alt="" className="w-full h-full object-cover" />
                  ) : (
                    <span className="text-xs font-bold">{tool.name.charAt(0)}</span>
                  )}
                </div>
                <span className="text-sm font-medium max-w-[100px] truncate">{tool.name}</span>
                <button 
                  onClick={() => removeTool(tool.id)}
                  className="p-0.5 hover:bg-background rounded transition-colors"
                >
                  <X className="h-3.5 w-3.5" />
                </button>
              </div>
            ))}
          </div>

          <div className="flex items-center gap-2">
            <Button variant="ghost" size="sm" onClick={clearAll}>
              Clear All
            </Button>
            <Button asChild disabled={selectedTools.length < 2}>
              <Link to="/compare">
                Compare Now
                <ArrowRight className="ml-1 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
